import {
    PAYMENT_PAGE_TYPE,
} from 'entities/payment-methods/constants';

export function formatSafeText(paymentPageType: PAYMENT_PAGE_TYPE): string {
    switch (paymentPageType) {
        case PAYMENT_PAGE_TYPE.DEFAULT: {
            return 'This account is verified and safe to use';
        }
        case PAYMENT_PAGE_TYPE.UPI_P2P:
        case PAYMENT_PAGE_TYPE.UPI_INTENT_QR: {
            return 'This UPI ID is verified and safe to use';
        }
    }
}
